import { take, takeLatest, takeEvery, select, put, fork } from 'redux-saga/effects'

import * as loginAndSignupActions from '../login-and-signup/actions'
import * as apiConstants from '../api/constants'
import * as authConstants from '../auth/constants'

import { LOCATION_CHANGE } from '../browser-location'

import * as actions from './actions'
import * as constants from './constants'
import { headerStateSelector } from './selectors'

function* userLoggedInSaga() {
    while (true) {
        yield take(authConstants.LOGIN)
        yield take(({ type, names }) => type === apiConstants.PROCESS_COMPLETED && names[0] === 'login')
        yield put(actions.closeAuth())
    }
}

function* closeAuthSaga() {
    yield takeLatest(constants.CLOSE_AUTH, function*() {
        yield put(loginAndSignupActions.resetState())
    })
}

function* closeAuthIfOpen() {
    const header = yield select(headerStateSelector)
    if (header.isAuthVisible) yield put(actions.closeAuth())
}

function* locationChangeSaga() {
    yield takeEvery(LOCATION_CHANGE, closeAuthIfOpen)
}

function* userLoggedOutSaga() {
    yield takeLatest(authConstants.LOGOUT, closeAuthIfOpen)
}

export function* rootSaga() {
    yield fork(userLoggedInSaga)
    yield fork(closeAuthSaga)
    yield fork(locationChangeSaga)
    yield fork(userLoggedOutSaga)
}
